export const CHECKOUT_URL =
  'https://megapackcmarasdeseguridadyalarmas.impultienda.ar/checkout'

export const OFFER_ANCHOR = '#oferta'

export const SUPPORT_EMAIL = 'soportescmdigital@gmail.com'

export const PACK_IMAGE =
  'https://cdn.magicpatterns.com/uploads/2ZvLXjS55v7mAe97mqQUMt/Imagen_de_Codex_11_sept_2026,_22_17_40.png'

export const PACK_IMAGE_ALT =
  'MEGA PACK CÁMARAS DE SEGURIDAD Y ALARMAS: 6 tomos digitales y 5 bonos incluidos'

export const PRODUCT_NAME = 'MEGA PACK CÁMARAS DE SEGURIDAD Y ALARMAS'
export const PRICE = '$19.990'
export const BONUS_TOTAL = '$39.950'

/* 1. PROBLEMA — ¿Te suena familiar? */
export const problems = [
  {
    icon: 'dizzy' as const,
    title: 'INFORMACIÓN DISPERSA',
    desc: 'Guardás videos sobre cámaras, DVR, NVR y alarmas, pero cada uno explica algo diferente y no sabés cómo conectar todo.',
  },
  {
    icon: 'question' as const,
    title: 'NO SABÉS QUÉ APRENDER PRIMERO',
    desc: 'CCTV, cámaras IP, cableado, DVR, redes, sensores... hay tantos conceptos que empezar parece complicado.',
  },
  {
    icon: 'camera' as const,
    title: 'TE FALTA UNA RUTA',
    desc: 'Tenés ganas de aprender una habilidad técnica, pero necesitás un camino que vaya desde los fundamentos hasta una instalación completa.',
  },
  {
    icon: 'clock' as const,
    title: 'SEGUÍS POSTERGANDO',
    desc: 'Querés comenzar, pero pasan las semanas y continuás mirando tutoriales en lugar de avanzar de forma ordenada.',
  },
]

/* 2. SOLUCIÓN — 6 TOMOS */
export const tomos = [
  {
    title: 'FUNDAMENTOS DE VIDEOVIGILANCIA Y SEGURIDAD ELECTRÓNICA',
    desc: 'Comprendé CCTV, cámaras IP, tipos de cámaras, resolución, DVR, NVR, almacenamiento, cableado, PoE y herramientas esenciales.',
  },
  {
    title: 'INSTALACIÓN PROFESIONAL DE CÁMARAS CCTV',
    desc: 'Aprendé relevamiento, ubicación de cámaras, cableado, conectores, alimentación, DVR, grabación y comprobaciones finales.',
  },
  {
    title: 'CÁMARAS IP, WI-FI Y REDES',
    desc: 'Comprendé IP, router, switch, PoE, cámaras Wi-Fi, NVR, redes y visualización remota mediante aplicaciones autorizadas.',
  },
  {
    title: 'ALARMAS, SENSORES Y SISTEMAS DE PROTECCIÓN',
    desc: 'Conocé centrales, sensores, contactos magnéticos, sirenas y la lógica necesaria para planificar sistemas de alarma.',
  },
  {
    title: 'DIAGNÓSTICO, FALLAS Y MANTENIMIENTO',
    desc: 'Aprendé a identificar problemas de imagen, alimentación, cableado, red, grabación, cámaras IP, alarmas y sensores.',
  },
  {
    title: 'INSTALACIONES REALES Y SALIDA LABORAL',
    desc: 'Aprendé relevamiento, materiales, presupuestos, organización, instalación, entrega y oportunidades para ofrecer tus servicios.',
  },
]

/* 3. BONOS */
export const bonuses = [
  {
    title: 'GUÍA MAESTRA DE DIAGNÓSTICO DE FALLAS™',
    desc: 'Encontrá el problema antes de cambiar equipos o perder horas revisando, con tablas y árboles de diagnóstico.',
    value: '$7.990',
  },
  {
    title: 'PACK DE CHECKLISTS DEL INSTALADOR PROFESIONAL™',
    desc: 'Listas prácticas para relevamientos, herramientas, materiales, instalación, configuración, pruebas y entrega.',
    value: '$5.990',
  },
  {
    title: 'KIT DE PRESUPUESTOS Y DOCUMENTOS PARA INSTALADORES™',
    desc: 'Plantillas para relevamientos, presupuestos, materiales, órdenes de trabajo, clientes y mantenimiento.',
    value: '$6.990',
  },
  {
    title: 'MANUAL RÁPIDO DE CONFIGURACIÓN DE CÁMARAS DESDE EL CELULAR™',
    desc: 'Una guía práctica para conectar, configurar y visualizar cámaras de forma remota mediante aplicaciones oficiales.',
    value: '$8.990',
  },
  {
    title: 'GUÍA PARA CONSEGUIR TUS PRIMEROS TRABAJOS COMO INSTALADOR™',
    desc: 'Recursos, estrategias y plantillas para empezar a presentar y ofrecer tus servicios de manera profesional.',
    value: '$9.990',
  },
]

/* 4. BENEFICIOS */
export const benefits = [
  {
    icon: 'camera' as const,
    title: 'MENOS CONFUSIÓN',
    desc: 'Dejá de saltar entre tutoriales y seguí una ruta desde los fundamentos hasta instalaciones completas.',
  },
  {
    icon: 'wrench' as const,
    title: 'MÁS CONOCIMIENTO PRÁCTICO',
    desc: 'Comprendé cámaras, DVR/NVR, cableado, redes, alarmas, sensores, configuración y diagnóstico con explicaciones claras.',
  },
  {
    icon: 'home' as const,
    title: 'COMPRENDÉ LO QUE ESTÁS INSTALANDO',
    desc: 'Empezá a mirar una propiedad y entender dónde ubicar cámaras, qué equipos necesitás y cómo funciona todo el sistema.',
  },
  {
    icon: 'rocket' as const,
    title: 'UNA NUEVA HABILIDAD',
    desc: 'Construí conocimientos que pueden convertirse en el primer paso para ofrecer servicios de instalación y mantenimiento.',
  },
]

/* 5. TESTIMONIOS */
export const testimonials = [
  {
    quote:
      'Tenía un montón de videos guardados sobre cámaras y nunca sabía por dónde empezar. Con los tomos ordenados entendí qué equipos necesito, cómo se conectan y qué función cumple cada parte. Ahora puedo mirar una instalación y entender mucho mejor cómo está armada.',
    author: 'Diego Fernández',
    role: 'Ayudante técnico, 27 años · Rosario, Argentina',
  },
  {
    quote:
      'Lo que más me sirvió fue la parte de diagnóstico. Antes, cuando una cámara no daba imagen, no sabía qué revisar primero. Ahora sigo un orden: alimentación, conexiones, cableado, grabador y configuración. Dejé de revisar cosas al azar.',
    author: 'Marcelo Ibáñez',
    role: 'Operario de mantenimiento, 41 años · Córdoba, Argentina',
  },
  {
    quote:
      'Necesitaba entender cámaras IP porque siempre me confundían las redes. El Tomo 3 me ayudó a comprender IP, router, NVR y PoE de una manera mucho más sencilla. Hoy entiendo cómo se relacionan los equipos.',
    author: 'Laura Quiroga',
    role: 'Encargada de mantenimiento, 35 años · Montevideo, Uruguay',
  },
  {
    quote:
      'Compré buscando aprender algo que pudiera aplicar y encontré una ruta completa. Cámaras, alarmas, diagnóstico y presupuestos están organizados paso a paso. Eso me ayudó mucho más que seguir saltando entre tutoriales.',
    author: 'Cristian Molina',
    role: 'Emprendedor, 32 años · Santiago, Chile',
  },
  {
    quote:
      'Ya conocía algunas cosas de electricidad, pero quería sumar cámaras y alarmas. Los checklists y las plantillas me dieron una estructura mucho más profesional para organizar materiales, revisar instalaciones y preparar presupuestos.',
    author: 'Héctor Ramírez',
    role: 'Instalador en formación, 48 años · Guadalajara, México',
  },
]

/* 6. FAQ */
export const faqs = [
  {
    q: '¿Es físico o digital?',
    a: 'Es un producto 100% digital.',
  },
  {
    q: '¿Necesito conocimientos previos?',
    a: 'No. El sistema arranca desde los fundamentos de videovigilancia y seguridad electrónica, así que podés empezar desde cero y avanzar paso a paso.',
  },
  {
    q: '¿Qué voy a aprender?',
    a: 'Cámaras CCTV e IP, DVR y NVR, cableado y PoE, redes y acceso remoto, alarmas, sensores y centrales, diagnóstico de fallas, mantenimiento, presupuestos e instalaciones reales.',
  },
  {
    q: '¿Incluye ejemplos prácticos?',
    a: 'Sí. Los tomos incluyen instalaciones explicadas paso a paso, árboles de diagnóstico, checklists y casos de relevamiento para que apliques lo aprendido.',
  },
  {
    q: '¿Los bonos tienen costo adicional?',
    a: 'No. Los 5 bonos, valorados en $39.950, están incluidos gratis con tu compra de hoy.',
  },
  {
    q: '¿Es un pago único?',
    a: 'Sí. Es un pago único de $19.990, sin mensualidades ni suscripciones.',
  },
  {
    q: '¿Obtengo acceso inmediatamente?',
    a: 'Sí. Una vez confirmado el pago recibís el acceso digital a los 6 tomos y los 5 bonos.',
  },
  {
    q: '¿Esto me habilita profesionalmente?',
    a: 'No. Es un material educativo: no sustituye formación profesional, práctica supervisada, licencias, certificaciones ni permisos cuando la normativa los exija.',
  },
  {
    q: '¿Puedo aprender a mi ritmo?',
    a: 'Sí. El acceso es digital y el contenido está organizado por tomos, así que avanzás según tus tiempos y podés releer cuando lo necesites.',
  },
  {
    q: '¿Dónde solicito soporte?',
    a: `Escribinos a ${SUPPORT_EMAIL} y te ayudamos con el acceso o con cualquier consulta sobre tu compra.`,
  },
]

/* POP-UP DE COMPRAS RECIENTES */
export const recentBuyers = [
  { name: 'Martín G.', city: 'Rosario, Santa Fe', minutes: 2 },
  { name: 'Lucía F.', city: 'Córdoba, Córdoba', minutes: 6 },
  { name: 'Pablo S.', city: 'La Matanza, Buenos Aires', minutes: 9 },
  { name: 'Andrés M.', city: 'Mendoza, Mendoza', minutes: 13 },
  { name: 'Sofía L.', city: 'La Plata, Buenos Aires', minutes: 17 },
  { name: 'Javier R.', city: 'Mar del Plata, Buenos Aires', minutes: 21 },
  { name: 'Nicolás B.', city: 'Salta, Salta', minutes: 26 },
  { name: 'Camila V.', city: 'San Miguel de Tucumán, Tucumán', minutes: 31 },
]
